<template>
    <v-container fluid>
        <MiniAlerts style="white-space: pre-line" v-if="alert.showAlert" :message="alert.message" />
        <validation-observer ref="form" v-slot="{ invalid }">
            <v-form @submit.prevent="submit">
                <v-row>
                    <v-col cols="12" md="2">
                        <v-menu
                            v-if="method == 'create'"
                            v-model="menu0"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                class="d-none d-lg-block"
                                v-model="fields.data"
                                label="Insira Data"
                                outlined dense
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            <v-text-field 
                                class="d-block d-lg-none" 
                                v-model="fields.data" 
                                type="date" 
                                id="birthday" 
                                label="Insira data"
                                dense outlined
                                :max="new Date(new Date()+1).toISOString().substr(0, 10)"
                            />
                            </template>
                            <v-date-picker
                                :allowed-dates="(date) => date <= new Date(new Date()+1).toISOString().substr(0, 10)"
                                v-model="fields.data"
                                @input="menu0 = false"
                                @change="dataChanged"
                            ></v-date-picker>
                        </v-menu>
                        <v-text-field
                            v-else
                            dense outlined
                            v-model="fields.data"
                            disabled
                            label="Data"
                        />
                    </v-col>
                    <v-col cols="12" md="4" v-if="fields.data != null">
                        <validation-provider v-slot="{ errors }" vid="Obras" name="Obras" rules="required">
                            <v-autocomplete
                                :disabled="method == 'update'"
                                v-model="fields.obra_id"
                                :items="obras"
                                outlined dense
                                :item-text="item => item.Codigo + ' - ' + item.Descricao"
                                item-value="Id"
                                :error-messages="errors"
                                label="Obras *"
                                @change="changeWork"
                            />
                        </validation-provider>
                    </v-col>
                    <!--<v-col cols="12" md="3" v-if="classeNeeded">
                        <validation-provider v-slot="{ errors }" vid="Classes" name="Classes" rules="required">
                            <v-autocomplete
                                :disabled="method == 'update'"
                                v-model="fields.classe_id"
                                :items="classes"
                                outlined dense
                                :item-text="item => item.Descricao"
                                item-value="ID"
                                :error-messages="errors"
                                label="Classe *"
                                @change="changeClasse"
                            />
                        </validation-provider>
                    </v-col>-->
                </v-row>
                <v-row v-if="showContent">
                    <v-col cols="12">
                        <v-simple-table class="d-none d-lg-block">
                            <template v-slot:default>
                                <thead class="primary">
                                    <tr>
                                        <th :colspan="classeNeeded ? '7' : '8'" class="text-left">
                                            <v-checkbox
                                                v-model="globalChecks.dividirMO"
                                                label="Dividir horas Mão de Obra"
                                                hide-details
                                                dense
                                                dark
                                                class="mr-6 d-inline-block"
                                            />
                                            <v-checkbox
                                                v-model="globalChecks.dividirEquip"
                                                label="Dividir horas Máquina"
                                                hide-details
                                                dense
                                                dark
                                                class="d-inline-block"
                                            />
                                        </th>
                                    </tr>
                                    <tr>                                             
                                        <th v-if="classeNeeded == false" width="25%" class="text-center white--text text-caption font-weight-bold">
                                            Frentes Obra
                                        </th>                        
                                        <th width="25%" class="text-center white--text text-caption font-weight-bold">
                                            Nome UO
                                        </th>
                                        <th v-if="showNature" width="15%" class="text-center white--text text-caption font-weight-bold">
                                            Natureza
                                        </th>
                                        <th v-if="showNature" width="12%" class="text-center white--text text-caption font-weight-bold">
                                            Unidade
                                        </th>
                                        <th width="15%" class="text-center white--text text-caption font-weight-bold">
                                            Produção
                                        </th>
                                        <th class="text-center white--text text-caption font-weight-bold">
                                            Notas
                                        </th>
                                        <th class="text-center white--text text-caption font-weight-bold">
                                            ...
                                        </th>
                                        <th class="text-center white--text text-caption font-weight-bold">
                                            Opções
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(item, index) in getLines" :key="item.id"
                                    >
                                        <td v-if="classeNeeded == false">
                                            <validation-provider v-slot="{ errors }" vid="Frentes" name="Frentes" rules="required">
                                                <v-autocomplete
                                                    v-model="item.obra_frente_id"
                                                    :items="frentes_obra"
                                                    outlined dense
                                                    :item-text="ob => getText(ob)"
                                                    item-value="ID"
                                                    class="mt-4"
                                                    :error-messages="errors"
                                                    label="Frentes de Obra *"
                                                    @change="changedFrente(item)"
                                                />
                                            </validation-provider>
                                        </td>
                                        <td>
                                            <validation-provider v-slot="{ errors }" vid="Classe" name="Classe" rules="required">
                                                <v-autocomplete
                                                    v-if="mqt!=null"
                                                    class="mt-4"
                                                    dense outlined
                                                    v-model="item.classe_id"
                                                    :items="item.available_classes"
                                                    :error-messages="errors"
                                                    clearable
                                                    :item-text="item => item.Descricao"
                                                    item-value="ID"
                                                    label="Classe *"
                                                    @change="onClasseChanged(item)"
                                                />
                                            </validation-provider>
                                        </td>                                        
                                        <td v-if="showNature">
                                            <validation-provider v-slot="{ errors }" vid="Natureza" name="Natureza" rules="required">
                                                <v-autocomplete
                                                    v-model="item.natureza_id"
                                                    :error-messages="errors"
                                                    :items="natureza_trabalhos"
                                                    :item-text="item=>item.code + ' - ' + item.natureza"
                                                    dense outlined
                                                    item-value="id"
                                                    label="Natureza *"
                                                    class="mt-4"
                                                    @change="onNaturezaChanged(item)"
                                                />
                                            </validation-provider>
                                        </td>
                                        <td v-if="showNature">
                                            <validation-provider v-slot="{ errors }" vid="Unidade" name="Unidade" rules="required">
                                                <v-autocomplete
                                                class="mt-4"
                                                dense
                                                outlined
                                                clearable
                                                :disabled="!item.natureza_id"
                                                v-model="item.id_lista_unidades"
                                                :items="getUnidadesForLine(item)"
                                                item-text="abreviacao"
                                                item-value="id"
                                                :error-messages="errors"
                                                label="Unidade *"
                                                />
                                            </validation-provider>
                                        </td>
                                        <td>
                                            <validation-provider v-slot="{ errors }" vid="Produção" name="Produção" rules="required">
                                                <v-text-field
                                                    label="Produção *"
                                                    class="mt-4"
                                                    dense outlined
                                                    :error-messages="errors"
                                                    clearable
                                                    v-model="item.producao"
                                                    type="number"
                                                />
                                            </validation-provider>
                                        </td>                                     
                                        <td>
                                            <validation-provider v-slot="{ errors }" vid="Local" name="Local" rules="|">
                                                <v-text-field
                                                    class="mt-4"
                                                    dense outlined
                                                    label="Local"
                                                    placeholder="Insira local"
                                                    v-model="item.notas"
                                                    @click="openEditorModal(item)"   
                                                />
                                            </validation-provider>
                                        </td>
                                        <td>
                                            <v-row no-gutters justify="center" align="center">
                                                <v-col cols="12" justify="center" align="center">
                                                    <v-btn :disabled="item.classe_id == null" class="primary" x-small rounded @click="openMaoObraDialog(item)">
                                                        Mão Obra
                                                    </v-btn>
                                                </v-col>
                                                <v-col cols="12" justify="center" align="center">
                                                    <v-btn :disabled="item.classe_id == null" class="primary" x-small rounded @click="openEquipamentoDialog(item)">
                                                        Equipamentos
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </td>
                                        <td>
                                            <v-btn
                                                dark
                                                x-small
                                                fab
                                                color="error"
                                                @click="deleteLine(item.id)"
                                                >
                                                <v-icon x-small>mdi-delete</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>

                        <v-data-iterator
                            :items="getLines"
                            item-key="id"
                            :items-per-page="-1"
                            hide-default-footer
                            class="d-block d-lg-none ma-0 pa-0"
                        >
                            <template v-slot:default="{ items }">
                                <v-row class="ma-0 pa-0">
                                    <v-col
                                        class="ma-0 pa-0"
                                        v-for="(item, index) in items"
                                        :key="item.id"
                                        cols="12"
                                    >
                                        <v-card elevation="0" class="mt-2 rounded-lg ma-0 pa-0" outlined>
                                            <v-list
                                                dense
                                            >
                                                <v-list-item>
                                                    <v-list-item-content class="align-center">
                                                        <validation-provider v-slot="{ errors }" vid="Unidade de Obra" name="Unidade de Obra" rules="required">
                                                            <v-autocomplete
                                                                v-if="mqt!=null"
                                                                class="mt-4"
                                                                dense outlined
                                                                v-model="item.classe_id"
                                                                :items="classes"
                                                                :error-messages="errors"
                                                                clearable
                                                                :item-text="item => item.Descricao"
                                                                item-value="ID"
                                                                label="Classe *"
                                                            />
                                                        </validation-provider>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item>
                                                    <v-list-item-content class="align-center">
                                                        <validation-provider v-slot="{ errors }" vid="Produção" name="Produção" rules="required">
                                                            <v-text-field
                                                                label="Produção *"
                                                                class="mt-4"
                                                                dense outlined
                                                                :error-messages="errors"
                                                                clearable
                                                                v-model="item.producao"
                                                                type="number"
                                                            />
                                                        </validation-provider>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item>
                                                    <v-list-item-content class="align-center">
                                                        <validation-provider v-slot="{ errors }" vid="Local" name="Local" rules="|">
                                                            <v-text-field
                                                                class="mt-4"
                                                                dense outlined
                                                                label="Local"
                                                                placeholder="Insira local"
                                                                v-model="item.notas"
                                                                @click="openEditorModal(item)"   
                                                            />
                                                        </validation-provider>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item>
                                                    <v-list-item-content class="align-center">
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item>
                                                    <v-list-item-content class="align-center">
                                                        <v-btn
                                                            dark
                                                            x-small
                                                            fab
                                                            color="error"
                                                            @click="deleteLine(item.id)"
                                                            >
                                                            <v-icon x-small>mdi-delete</v-icon>
                                                        </v-btn>
                                                    </v-list-item-content>
                                                </v-list-item>

                                            </v-list>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-data-iterator>
                    </v-col>
                    <v-col cols="12" align="center">
                        <v-btn fab @click="addLineToTable" class="primary">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>  
                <v-row v-if="showContent">
                    <!-- LISTAGEM MATERIAIS -->
                    <v-col cols="12" class="ma-0 pa-0">
                        <v-card elevation="0">
                            <v-card-title class="primary white--text">
                                {{loadedMaterials ? 'Materiais' : 'A carregar materiais...'}}
                            </v-card-title>
                            <v-card-text class="mt-2">
                                <v-row :key="reloadMateriaisKey">
                                    <v-col cols="12" v-for="(naturezas, classe) in groupedMaterials" :key="classe">
                                    <h3 class="font-weight-bold">{{ classe }}</h3>
                                    <div v-for="(materiais, natureza) in naturezas" :key="classe + natureza" class="ml-4">
                                        <h4 class="font-italic">{{ natureza }}</h4>
                                        <ul class="ml-4">
                                            <li
                                                v-for="(material, idx) in materiais"
                                                :key="[
                                                    'mat',
                                                    (material.material && material.material.artigo) || material.id,
                                                    (material.classe && material.classe.ID) || 'noClasse',
                                                    (material.natureza && material.natureza.id) || 'noNat'
                                                ].join('-')"
                                                >
                                                <strong>{{ material.unidade }}</strong> — {{ material.descricao }}

                                                <v-row dense class="mt-1" align="center">
                                                    <v-col cols="12">
                                                        <v-text-field
                                                            v-model.number="material.referencia.qty"
                                                            dense outlined hide-details
                                                            type="text" inputmode="decimal"
                                                            label="Quantidade"
                                                            style="max-width: 100px;"
                                                            @blur="material.referencia.qty = toNumber(material.referencia.qty)"
                                                        />
                                                    </v-col>
                                                </v-row>
                                            </li>
                                        </ul>
                                    </div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row v-if="showContent">
                    <v-col cols="12" class="ma-0 pa-0">
                        <v-card elevation="0">
                            <v-card-title class="primary white--text">
                                {{loadedSubempreitadas ? 'Subempreitadas' : 'A carregar subempreitadas...'}}
                            </v-card-title>
                            <v-card-text class="mt-2">
                                <v-row :key="reloadSubempreitadasKey">
                                    <v-col cols="12" v-for="(naturezas, classe) in groupedSubempreitadas" :key="classe">
                                    <h3 class="font-weight-bold">{{ classe }}</h3>
                                    <div v-for="(subempreitadas, natureza) in naturezas" :key="classe + natureza" class="ml-4">
                                        <h4 class="font-italic">{{ natureza }}</h4>
                                        <ul class="ml-4">
                                            <li v-for="(subempreitada, idx) in subempreitadas" :key="subempreitada.id">
                                                {{ subempreitada.descricao }}

                                                <v-row dense class="mt-1" align="center">
                                                    <v-col cols="12">
                                                        <v-text-field
                                                            v-model="subempreitada.referencia.qty"
                                                            dense outlined
                                                            hide-details
                                                            type="number"
                                                            label="Quantidade"
                                                            style="max-width: 100px;"
                                                        />
                                                    </v-col>
                                                </v-row>
                                            </li>
                                        </ul>
                                    </div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row v-if="showContent" class="mt-4">
                    <v-col cols="12" align="end">
                        <v-btn v-if="!hideButtonSave" :disabled="invalid" type="submit" class="success" rounded>
                            Gravar<v-icon class="ml-2">mdi-content-save</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>          
            </v-form>
        </validation-observer>

        <v-dialog
            v-if="editorModal"
            v-model="editorModal"
            max-width="600px"
            scrollable
        >
            <InputEditorModal @change-value="changeEditorModal" vid="editor_local" :title="'Local'" :label="'Local'" v-model="inputEditorModalData.itemModel"/>
        </v-dialog>

        <DialogSuccess :opened="success" @on-ok="onSuccess" >
            Diária gravada com sucesso
        </DialogSuccess>


        <!-- DIALOG DE MAO DE OBRA -->
        <v-dialog v-model="moDialog" max-width="600px">
            <v-card>
                <v-card-title class="primary white--text">
                Editar Mão de Obra
                </v-card-title>

                <v-card-text>
                    <v-tabs v-model="moTab" background-color="orange" grow>
                        <v-tab>MO INTERNA</v-tab>
                        <v-tab>MO EXTERNA</v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="moTab">
                        <!-- Tab Interna -->
                        <v-tab-item>
                            <v-card flat>
                            <v-card-text>
                                <v-row v-if="working_mo.internos.length === 0" class="text-center">
                                <v-col cols="12">Sem registos</v-col>
                                </v-row>
                                <v-row v-for="(mo, idx) in working_mo.internos" :key="'int-'+idx">
                                <v-col cols="8">{{ mo.Nome }}</v-col>
                                <v-col cols="4">
                                    <v-text-field v-model.number="mo.hours" label="Horas" type="number" dense hide-details />
                                </v-col>
                                </v-row>
                            </v-card-text>
                            </v-card>
                        </v-tab-item>

                        <!-- Tab Externa -->
                        <v-tab-item>
                            <v-card flat>
                            <v-card-text>
                                <v-row v-if="working_mo.externos.length === 0" class="text-center">
                                <v-col cols="12">Sem registos</v-col>
                                </v-row>
                                <v-row v-for="(mo, idx) in working_mo.externos" :key="'ext-'+idx">
                                <v-col cols="8">{{ mo.Nome }}</v-col>
                                <v-col cols="4">
                                    <v-text-field v-model.number="mo.hours" label="Horas" type="number" dense hide-details />
                                </v-col>
                                </v-row>
                            </v-card-text>
                            </v-card>
                        </v-tab-item>
                        </v-tabs-items>
                </v-card-text>

                <v-card-actions>
                <v-spacer />
                <v-btn text color="grey" @click="moDialog = false">Cancelar</v-btn>
                <v-btn color="primary" @click="gravarHorasMO">Gravar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- DIALOG DE EQUIPAMENTOS -->
        <v-dialog v-model="equipDialog" max-width="600px">
            <v-card>
                <v-card-title class="primary white--text">
                Editar Equipamentos
                </v-card-title>

                <v-card-text>
                <v-tabs v-model="equipTab" background-color="orange" grow>
                    <v-tab>EQUIP. INTERNO</v-tab>
                    <v-tab>EQUIP. EXTERNO</v-tab>
                </v-tabs>

                <v-tabs-items v-model="equipTab">
                    <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                        <v-row v-if="working_equip.internos.length === 0" class="text-center">
                            <v-col cols="12">Sem registos</v-col>
                        </v-row>
                        <v-row v-for="(eq, idx) in working_equip.internos" :key="'int-eq-' + idx">
                            <v-col cols="8">{{ eq.Descricao }}</v-col>
                            <v-col cols="4">
                            <v-text-field v-model.number="eq.hours" label="Horas" type="number" dense hide-details />
                            </v-col>
                        </v-row>
                        </v-card-text>
                    </v-card>
                    </v-tab-item>

                    <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                        <v-row v-if="working_equip.externos.length === 0" class="text-center">
                            <v-col cols="12">Sem registos</v-col>
                        </v-row>
                        <v-row v-for="(eq, idx) in working_equip.externos" :key="'ext-eq-' + idx">
                            <v-col cols="8">{{ eq.Descricao }}</v-col>
                            <v-col cols="4">
                            <v-text-field v-model.number="eq.hours" label="Horas" type="number" dense hide-details />
                            </v-col>
                        </v-row>
                        </v-card-text>
                    </v-card>
                    </v-tab-item>
                </v-tabs-items>
                </v-card-text>

                <v-card-actions>
                <v-spacer />
                <v-btn text color="grey" @click="equipDialog = false">Cancelar</v-btn>
                <v-btn color="primary" @click="gravarHorasEquipamentos">Gravar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!-- DIALOG DIARIA REPETIDA -->
        <v-dialog v-model="diaryExistsDialog" max-width="600px">
            <v-card>
                <v-card-title class="primary white--text">
                Diária repetida
                </v-card-title>

                <v-card-text>
                Já existe uma diária para este dia e para esta obra.  
                Se quiseres, podemos abrir a mesma para editar.  
                Caso contrário, carregue em cancelar.
                </v-card-text>

                <v-card-actions>
                <v-spacer />
                <v-btn text color="grey" @click="fields.obra_id = null; fields.data = null; diaryExistsDialog = false;">Cancelar</v-btn>
                <v-btn color="primary" @click="openDiaryKPI">Abrir</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-container>
</template>
<script>
import DateInput from "@/components/UI/Inputs/DateInput"
import InputEditorModal from "@/components/UI/Modals/InputEditorModal";
import Obra from "@/api/Obra.js"
import FrenteObra from "@/api/FrenteObra.js"
import UnidadesObra from "@/api/UnidadesObra.js"
import DiaryKPI from "@/api/DiaryKPI.js"
import Classe from "@/api/Classe.js"
import NaturezaTrabalhos from "@/api/NaturezaTrabalhos.js"
import Materiais from "@/api/Materiais.js"
import SubEmpreitada from "@/api/SubEmpreitada.js"
import dayjs from 'dayjs'
import ErrorSnackbar from "@/components/UI/Snackbars/ErrorSnackbar";
import ConfirmModal from '@/components/Modals/ConfirmModal.vue';
import SuccessSnackbar from "@/components/UI/Snackbars/SuccessSnackbar";
import Loader from "@/components/UI/Loaders/Loader";
import MiniAlerts from '@/components/Alerts/MiniAlerts.vue';
import Tooltip from '@/components/UI/Tooltip.vue';
import DialogSuccess from '@/components/UI/DialogSuccess.vue';

export default{
    name:"DiaryKPI",
    components:{
        DateInput,
        DialogSuccess,
        InputEditorModal,
        ErrorSnackbar,
        ConfirmModal,
        SuccessSnackbar,
        Loader,
        MiniAlerts,
        Tooltip
    },
    props:{
        method: String,
        diary: Object,
    },
    watch:{
        'globalChecks.dividirMO'(val) {
            if (!val) return;

            const totaisPorFuncionarioPorClasse = {}; // 👈 ESTA LINHA É OBRIGATÓRIA

            // 👉 Filtrar mo_internos únicos
            const mo_internos = [];
            const seenFuncionarios = new Set();

            this.mao_obra.internos.forEach(mo => {
                if (!mo?.funcionario) return;

                if (!seenFuncionarios.has(mo.funcionario)) {
                    mo_internos.push(mo);
                    seenFuncionarios.add(mo.funcionario);
                }
            });

            // 👉 Filtrar mo_externos únicos
            const mo_externos = [];
            const seenExternos = new Set();

            this.mao_obra.externos.forEach(mo => {
            if (!mo?.funcionario) return;

            if (!seenExternos.has(mo.funcionario)) {
                mo_externos.push(mo);
                seenExternos.add(mo.funcionario);
            }
            });

            // 1. Soma HNormal + HExtra por funcionario e por ClasseID
            const todosMO = [...mo_internos, ...mo_externos];
            todosMO.forEach(mo => {
                if (!mo?.funcionario || !mo.ClasseID) return;

                const key = `${mo.funcionario}_${mo.ClasseID}`;
                if (!totaisPorFuncionarioPorClasse[key]) {
                totaisPorFuncionarioPorClasse[key] = 0;
                }

                const normal = parseFloat(mo.HNormal || 0);
                const extra  = parseFloat(mo.HExtra  || 0);
                totaisPorFuncionarioPorClasse[key] += normal + extra;
            });
            console.log(totaisPorFuncionarioPorClasse)
            


            // 2. Conta em quantas linhas aparece cada funcionario por ClasseID
            const contadorPorFuncionarioClasse = {};

            for (const linhaId in this.fields.mao_obra) {
                const linha = this.line.find(l => l.id == linhaId);
                if (!linha?.classe_id) continue;

                const grupo = this.fields.mao_obra[linhaId];

                [...grupo.internos, ...grupo.externos].forEach(mo => {
                if (!mo?.funcionario) return;

                const key = `${mo.funcionario}_${linha.classe_id}`;
                if (!contadorPorFuncionarioClasse[key]) {
                    contadorPorFuncionarioClasse[key] = 0;
                }

                contadorPorFuncionarioClasse[key]++;
                });
            }
            // 3. Atualiza os hours com base na ClasseID
            for (const linhaId in this.fields.mao_obra) {
                const linha = this.line.find(l => l.id == linhaId);
                if (!linha?.classe_id) continue;

                const grupo = this.fields.mao_obra[linhaId];

                ['internos', 'externos'].forEach(tipo => {
                grupo[tipo].forEach(mo => {
                    const key   = `${mo.funcionario}_${linha.classe_id}`;
                    const total = totaisPorFuncionarioPorClasse[key] || 0;
                    const count = contadorPorFuncionarioClasse[key] || 1;
                    mo.hours = +(total / count).toFixed(2);
                });
                });
            }

            // 4. Sincroniza com this.line
            this.line.forEach(linha => {
                const grupo = this.fields.mao_obra[linha.id];
                if (!grupo) return;

                linha.linhas_mo_internal = JSON.parse(JSON.stringify(grupo.internos));
                linha.linhas_mo_external = JSON.parse(JSON.stringify(grupo.externos));
            });
        },
        'globalChecks.dividirEquip'(val) {
            if (!val) return;

            const totaisPorEquipPorClasse = {};

            // 👉 Filtrar eq_internos únicos
            const eq_internos = [];
            const seenEquipamentos = new Set();

            this.equipamentos.internos.forEach(eq => {
                if (!eq?.equipamento) return;

                if (!seenEquipamentos.has(eq.equipamento)) {
                    eq_internos.push(eq);
                    seenEquipamentos.add(eq.equipamento);
                }
            });

            // 👉 Filtrar eq_externos únicos
            const eq_externos = [];
            const seenExternos = new Set();

            this.equipamentos.externos.forEach(eq => {
            if (!eq?.equipamento) return;

            if (!seenExternos.has(eq.equipamento)) {
                eq_externos.push(eq);
                seenExternos.add(eq.equipamento);
            }
            });


            // 1. Soma HNormal + HExtra por equipamento e ClasseID
            const todosEquip = [...eq_internos, ...eq_externos];

            todosEquip.forEach(eq => {
                if (!eq?.equipamento || !eq.ClasseID) return;

                const key = `${eq.equipamento}_${eq.ClasseID}`;
                if (!totaisPorEquipPorClasse[key]) {
                totaisPorEquipPorClasse[key] = 0;
                }

                const normal = parseFloat(eq.Servico || 0);
                totaisPorEquipPorClasse[key] += normal;
            });

            console.log(totaisPorEquipPorClasse)

            // 2. Conta em quantas linhas aparece cada equipamento por ClasseID
            const contadorPorEquipClasse = {};

            for (const linhaId in this.fields.equipamentos) {
                const linha = this.line.find(l => l.id == linhaId);
                if (!linha?.classe_id) continue;

                const grupo = this.fields.equipamentos[linhaId];

                [...grupo.internos, ...grupo.externos].forEach(eq => {
                if (!eq?.equipamento) return;

                const key = `${eq.equipamento}_${linha.classe_id}`;
                if (!contadorPorEquipClasse[key]) {
                    contadorPorEquipClasse[key] = 0;
                }

                contadorPorEquipClasse[key]++;
                });
            }

            // 3. Atualiza os hours com base na ClasseID
            for (const linhaId in this.fields.equipamentos) {
                const linha = this.line.find(l => l.id == linhaId);
                if (!linha?.classe_id) continue;

                const grupo = this.fields.equipamentos[linhaId];

                ['internos', 'externos'].forEach(tipo => {
                grupo[tipo].forEach(eq => {
                    const key   = `${eq.equipamento}_${linha.classe_id}`;
                    const total = totaisPorEquipPorClasse[key] || 0;
                    const count = contadorPorEquipClasse[key] || 1;
                    eq.hours = +(total / count).toFixed(2);
                });
                });
            }

            // 4. Sincroniza com this.line[*].linhas_eq_internal/external
            this.line.forEach(linha => {
                const grupo = this.fields.equipamentos[linha.id];
                if (!grupo) return;

                linha.linhas_eq_internal = JSON.parse(JSON.stringify(grupo.internos));
                linha.linhas_eq_external = JSON.parse(JSON.stringify(grupo.externos));
            });
        },
        diary: {
        immediate: true,
            async handler (val) {
                if (!val) return;

                let data = { ...val };

                this.fields = data;

                // 👇 ADICIONA ISTO
                this.fields.materials = Array.isArray(data.materials) ? data.materials : [];

                if (this.fields.frente_id == null) this.hideFrentes = true;

                this.line = this.fields.lines;
                this.line.forEach(l => {
                    if (!l.natureza_id) return;

                    // se o backend ainda não mandou id_lista_unidades mas a natureza só tem 1 unidade:
                    if (!l.id_lista_unidades) {
                        const nat = this.natureza_trabalhos.find(n => n.id === l.natureza_id);
                        if (nat?.lista_unidades?.length === 1) {
                        l.id_lista_unidades = nat.lista_unidades[0].id;
                        }
                    }
                });

                this.fields.mao_obra = {};

                await this.loadMaoObra();

                this.fields.lines.forEach(linha => {
                const internos = (linha.linhas_mo_internal || []).map(mo => {
                    const found = this.mao_obra.internos?.find(p => p.funcionario === mo.funcionario);
                    return {
                    ...mo,
                    Nome: found?.Nome || 'Desconhecido'
                    };
                });

                const externos = (linha.linhas_mo_external || []).map(mo => {
                    const found = this.mao_obra.externos?.find(p => p.funcionario === mo.funcionario);
                    return {
                    ...mo,
                    Nome: found?.Nome || 'Desconhecido'
                    };
                });

                this.$set(this.fields.mao_obra, linha.id, { internos, externos });
                });

                await this.loadEquipamentos()

                this.fields.equipamentos = {};

                this.fields.lines.forEach(linha => {
                    const internos = (linha.linhas_eq_internal || []).map(eq => {
                        const found = this.equipamentos?.internos?.find(e => e.equipamento === eq.equipamento);
                        return {
                            ...eq,
                            Descricao: found?.Descricao || 'Desconhecido'
                        };
                    });

                    const externos = (linha.linhas_eq_external || []).map(eq => {
                        const found = this.equipamentos?.externos?.find(e => e.equipamento === eq.equipamento);
                        return {
                            ...eq,
                            Descricao: found?.Descricao || 'Desconhecido'
                        };
                    });

                    this.$set(this.fields.equipamentos, linha.id, { internos, externos });
                });

                this.loadingContent = 0

                this.changeWork()

                this.classesPorObra()

                this.showContent = true
            }
        },
    },
    data(){
        return{
            editorModal: false,
            menu0: false,
            menu1: false,
            menu2: false,
            loadedMaterials: false,
            loadedSubempreitadas: false,
            hideButtonSave: false,
            classeNeeded: false,
            confirmationModal: {
                show: false,
                title: '',
                message: ''
            },
            alert:{
                showAlert: false,
                message: ''
            },
            loadingContent: 2,
            hideFrentes: false,
            error: false,
            timeout: 2000,
            error_message: "",
            showContent: false,
            editorModal:false,
            success: false,
            loader: false,
            mqt: null,
            inputEditorModalData:{
                itemModel:null,
                id: null,
            },  
            materialsIndex: {}, // key: "artigo|classe|natureza" -> { artigo, classe_id, natureza_id, qty }
            fields:{
                obra_id: null,
                frente_id: null,
                classe_id: null,
                data: null,
                materials: [],
                mao_obra: {},
                equipamentos:{}
            },
            natureza_trabalhos: [],
            deletedLines: [],
            line: [
                {
                    id: dayjs().unix() + '-new',
                    natureza_id: null,
                    classe_id: null,
                    id_lista_unidades: null,
                    producao: null,
                    notas: null
                }
            ],
            obras: [],
            classes:[],
            frentes_obra: [],
            materiais: [],
            reloadMateriaisKey: 9000,
            reloadSubempreitadasKey: 8000,
            materiais_diaria: [],
            subempreitadas_diaria: [],
            subempreitadas_array: [],
            mao_obra: [],
            equipamentos: [],
            moDialog: false,
            working_mo: {
                internos: [],
                externos: []
            },
            editingItem: null,
            moTab: 0,
            editingEquipamentoItem: null,
            equipDialog: false,
            equipTab: 0,
            working_equip: {
                internos: [],
                externos: []
            },
            globalChecks:{
                dividirMO: false,
                dividirEquip: false
            },
            existingData: null,
            diaryExistsDialog: false,
        }
    },
    mounted(){
        this.fillBaseData()
    },
    methods:{ 
        getNaturezaById(id) {
            if (!id) return null;
            return this.natureza_trabalhos.find(n => n.id === id) || null;
        },

        getUnidadesForLine(line) {
            const nat = this.getNaturezaById(line.natureza_id);
            return nat?.lista_unidades || [];
        },

        onNaturezaChanged(line) {
            // reset sempre que muda
            line.id_lista_unidades = null;

            const unidades = this.getUnidadesForLine(line);

            // se só há uma unidade, fica por defeito
            if (unidades.length === 1) {
            line.id_lista_unidades = unidades[0].id;
            }
        },
        changedFrente(item){
            let classes = []
            this.frentes_obra.forEach(element => {
                if(element.ID == item.obra_frente_id)
                    classes= element.classes
            });

            item.available_classes = classes
        },
        ensureMatRef(key, def) {
            if (!this.materialsIndex[key]) {
            // cria uma referência nova só para esta combinação
            this.$set(this.materialsIndex, key, {
                artigo: def.artigo,
                classe_id: def.classe_id,
                natureza_id: def.natureza_id,
                qty: this.toNumber(def.qty || 0),
            });
            } else {
            // se ainda não tem qty definida, inicializa
            const cur = this.materialsIndex[key];
            if (cur.qty == null && def.qty != null) {
                cur.qty = this.toNumber(def.qty);
            }
            }
            return this.materialsIndex[key];
        },
        toNumber(v) {
            if (v === null || v === undefined || v === '') return 0;
            if (typeof v === 'string') v = v.replace(',', '.');
            const n = parseFloat(v);
            return Number.isFinite(n) ? n : 0;
        },
        openDiaryKPI() {
            if (this.existingData?.id) {
                this.$router.push(`/kpi/edit/${this.existingData.id}`);
            }
        },
        async getData(){
            let data = {
                data: this.fields.data,
                obra_id: this.fields.obra_id
            }
            await DiaryKPI.getData(data).then((resp) =>  {
                this.existingData = resp.data
                if(this.existingData != ''){
                    this.diaryExistsDialog = true; // <-- mostrar a dialog
                }
            })

            if(this.diaryExistsDialog == true)
                return false

            return true
        },
        onClasseChanged(item) {
            const linhaId  = item.id;
            const classeId = item.classe_id;

            if (!classeId) return;

            // MÃO DE OBRA
            if (!this.fields.mao_obra[linhaId]) {
                const makeMO = (src) => {
                    const seen = new Set();
                    return src
                        .filter(m => m.ClasseID == classeId && !seen.has(m.funcionario) && seen.add(m.funcionario))
                        .map(m => ({
                            funcionario : m.funcionario,
                            ClasseID    : m.ClasseID,
                            Nome        : m.Nome || 'Desconhecido',
                            hours       : 0,
                        }));
                };

                this.$set(this.fields.mao_obra, linhaId, {
                    internos: makeMO(this.mao_obra.internos),
                    externos: makeMO(this.mao_obra.externos),
                });
            }

            // EQUIPAMENTOS
            if (!this.fields.equipamentos[linhaId]) {
                const makeEquip = (src) => {
                    const seen = new Set();
                    return src
                        .filter(e => e.ClasseID == classeId && !seen.has(e.equipamento) && seen.add(e.equipamento))
                        .map(e => ({
                            equipamento: e.equipamento,
                            ClasseID: e.ClasseID,
                            Descricao: e.Descricao || 'Desconhecido',
                            hours: 0,
                        }));
                };

                this.$set(this.fields.equipamentos, linhaId, {
                    internos: makeEquip(this.equipamentos.internos),
                    externos: makeEquip(this.equipamentos.externos),
                });
            }
        },
        gravarHorasEquipamentos() {
            const linhaId = this.editingEquipamentoItem.id;
            this.$set(this.fields.equipamentos, linhaId, structuredClone(this.working_equip));
            this.equipDialog = false;
        },
        openEquipamentoDialog(item) {
            const linhaId = item.id;
            const classeId = item.classe_id;

            if (!this.fields.equipamentos) this.fields.equipamentos = {};
            
            if (!this.fields.equipamentos[linhaId]) {
                const makeEquipRow = (src) => {
                    const seen = new Set();
                    return src
                        .filter(e => e.ClasseID == classeId && !seen.has(e.equipamento) && seen.add(e.equipamento))
                        .map(e => ({
                            equipamento: e.equipamento,
                            ClasseID: e.ClasseID,
                            Descricao: e.Descricao || 'Desconhecido',
                            hours: 0,
                        }));
                };

                this.$set(this.fields.equipamentos, linhaId, {
                    internos: makeEquipRow(this.equipamentos.internos),
                    externos: makeEquipRow(this.equipamentos.externos),
                });
            }

            this.$set(this, 'working_equip', structuredClone(this.fields.equipamentos[linhaId]));

            this.$nextTick(() => {
                this.editingEquipamentoItem = item;
                this.equipDialog = true;
            });
        },
        gravarHorasMO() {
            const linhaId = this.editingItem.id;
            this.$set(this.fields.mao_obra, linhaId, JSON.parse(JSON.stringify(this.working_mo)));
            this.moDialog = false;
        },
        openMaoObraDialog(item){
            const linhaId  = item.id;
            const classeId = item.classe_id;

            /* 1. prepara (ou cria) a mão‑de‑obra para a linha ------------------ */
            if (!this.fields.mao_obra[linhaId]) {
                const makeRow = (src) => {
                    const seen = new Set();
                    return src
                        .filter(m => m.ClasseID == classeId && !seen.has(m.funcionario) && seen.add(m.funcionario))
                        .map(m => ({
                            funcionario : m.funcionario,
                            ClasseID    : m.ClasseID,
                            Nome        : m.Nome || 'Desconhecido',
                            hours       : 0,
                        }));
                };
                    
                    // Percorrer internos e remover repetidos

                    // Percorrer externos e remover repetidos

                    this.$set(this.fields.mao_obra, linhaId, {
                        internos : makeRow(this.mao_obra.internos),
                        externos : makeRow(this.mao_obra.externos),
                    });
            }

            /* 2. **clona** sem quebrar reactividade ---------------------------- */
            // usamos structuredClone (ou lodash.cloneDeep) e depois $set
            this.$set(this, 'working_mo',
                structuredClone(this.fields.mao_obra[linhaId])
            );

            /* 3. só depois de o novo objecto estar “reactivo”, abre o diálogo -- */
            this.$nextTick(() => {
                this.editingItem = item;
                this.moDialog    = true;
            });
        },
        reloadMateriais(){
            // Cria uma nova referência — força o Vue a reavaliar o computed
            this.materiais_diaria = JSON.parse(JSON.stringify(this.materiais_diaria));

            // Opcional, apenas se quiseres que o DOM se redesenhe via :key
            this.reloadMateriaisKey++;
        },
        async loadEquipamentos(){
            let data = {
                data: this.fields.data,
                obra: this.fields.obra_id
            }
            await DiaryKPI.getEquipamentos(data).then((resp) =>  {
                this.equipamentos = resp.data
            })
        },
        async loadMaoObra(){
            let data = {
                data: this.fields.data,
                obra: this.fields.obra_id
            }
            await DiaryKPI.getMaoObra(data).then((resp) =>  {
                this.mao_obra = resp.data
            })
        },
        async loadMateriais(){
            let data = {
                data: this.fields.data,
                obra: this.fields.obra_id
            }
            await DiaryKPI.getMateriais(data).then((resp) =>  {
                this.materiais_diaria = resp.data
            })

            let materialsData ={
                id_frente_obra: "null",
                id_obra_classe: "null",
                obra_id: this.fields.obra_id
            }

            await Materiais.getList(materialsData).then((resp)    =>  {
                this.materiais = resp.data
                this.loadedMaterials = true
            })
        },
        async loadSubempreitadas(){
            let data = {
                data: this.fields.data,
                obra: this.fields.obra_id
            }
            await DiaryKPI.getSubempreitadas(data).then((resp) =>  {
                this.subempreitadas_diaria = resp.data
            })
            
            await SubEmpreitada.all(this.fields.obra_id).then((resp)   =>  {
                this.subempreitadas_array = resp.data
                this.loadedSubempreitadas = true
            })
        },
        getText(ob) {
            if (ob.Descricao && ob.SubEmp && ob.Descricao.includes(ob.SubEmp)) {
                return ob.Descricao;
            }

            return `${ob.SubEmp} - ${ob.Descricao}`;
        },
        deleteLine(){
            if(this.line.length == 1){
                this.error_message = "Não pode apagar a única linha que tem"
                this.error = true
                return
            }
                
            let index = this.line.findIndex(item => item.id == id);

            this.line.splice(index, 1);

            if(!id.includes('new'))
                this.deletedLines.push(id)
        },
        onSuccess(){
            if(this.method == 'update'){
                window.location.reload()
                return
            }

            this.success = false;
            this.$router.push('/kpi/lista-de-diarios')
        },
        submit() {
            this.hideButtonSave = true;

            this.fields.lines = this.line;
            this.fields.deletedLines = this.deletedLines;

            // ---- materiais (agrupar por artigo+classe, com array de naturezas)
            const byMat = {};
            Object.values(this.materialsIndex).forEach(ref => {
                const qty = this.toNumber(ref.qty);
                if (!qty) return; // ignora zeros se quiseres

                const key = `${ref.artigo}|${ref.classe_id}`;
                if (!byMat[key]) {
                byMat[key] = { artigo: ref.artigo, classe_id: ref.classe_id, naturezas: [] };
                }

                const arr = byMat[key].naturezas;
                const i = arr.findIndex(n => n.natureza_id === ref.natureza_id);
                if (i === -1) arr.push({ natureza_id: ref.natureza_id, qty });
                else          arr[i].qty += qty;
            });

            this.fields.materials = Object.values(byMat);
            /* -------------------------------------------------------------------------------- */

            /* ---------------------- SUBEMPREITADAS (igual à tua lógica) -------------------- */
            const subempreitadas_a_inserir = [];
            this.subempreitadas_diaria.forEach(sub => {
                const linha = this.line.find(l => l.classe_id === sub.classe_extended_id);
                if (linha && linha.natureza_id != null) {
                sub.natureza_id = linha.natureza_id;
                subempreitadas_a_inserir.push(sub);
                }
            });
            this.fields.subempreitadas = subempreitadas_a_inserir;
            /* -------------------------------------------------------------------------------- */

            /* ---------------------- MÃO DE OBRA -------------------------------------------- */
            this.fields.moInterna = [];
            this.fields.moExterna = [];

            for (const linhaId in this.fields.mao_obra) {
                const grupo = this.fields.mao_obra[linhaId];
                const linha = this.line.find(l => l.id == linhaId);
                const naturezaId = linha?.natureza_id ?? null;
                const classeId   = linha?.classe_id   ?? null;

                grupo.internos.forEach(mo => {
                this.fields.moInterna.push({
                    ...mo,
                    linha_id: linhaId,
                    natureza_id: naturezaId,
                    classe_id: classeId
                });
                });

                grupo.externos.forEach(mo => {
                this.fields.moExterna.push({
                    ...mo,
                    linha_id: linhaId,
                    natureza_id: naturezaId,
                    classe_id: classeId
                });
                });
            }

            // Garante arrays nas linhas e injeta MO nas lines (para voltar a abrir pré-preenchido)
            this.line.forEach(l => {
                if (!l.linhas_mo_internal) l.linhas_mo_internal = [];
                if (!l.linhas_mo_external) l.linhas_mo_external = [];
            });
            for (const linhaId in this.fields.mao_obra) {
                const grupo = this.fields.mao_obra[linhaId];
                const linha = this.line.find(l => l.id == linhaId);
                if (!linha) continue;
                linha.linhas_mo_internal = JSON.parse(JSON.stringify(grupo.internos));
                linha.linhas_mo_external = JSON.parse(JSON.stringify(grupo.externos));
            }
            /* -------------------------------------------------------------------------------- */

            /* ---------------------- EQUIPAMENTOS ------------------------------------------- */
            this.fields.equipInterno = [];
            this.fields.equipExterno = [];

            if (this.fields.equipamentos) {
                for (const linhaId in this.fields.equipamentos) {
                const grupo = this.fields.equipamentos[linhaId];
                const linha = this.line.find(l => l.id == linhaId);
                const naturezaId = linha?.natureza_id ?? null;
                const classeId   = linha?.classe_id   ?? null;

                grupo.internos.forEach(eq => {
                    this.fields.equipInterno.push({
                    ...eq,
                    linha_id    : linhaId,
                    natureza_id : naturezaId,
                    classe_id   : classeId,
                    });
                });

                grupo.externos.forEach(eq => {
                    this.fields.equipExterno.push({
                    ...eq,
                    linha_id    : linhaId,
                    natureza_id : naturezaId,
                    classe_id   : classeId,
                    });
                });

                // guarda nas lines para reabrir com dados
                linha.linhas_eq_internal = JSON.parse(JSON.stringify(grupo.internos));
                linha.linhas_eq_external = JSON.parse(JSON.stringify(grupo.externos));
                }
            }
            /* -------------------------------------------------------------------------------- */

            // 2) gravar
            DiaryKPI[this.method](this.fields, this.fields.id).then(() => {
                this.success = true;
                this.hideButtonSave = false;
            });
        },
        changeEditorModal(e){
            this.line.forEach(element => {
                if(element.id == this.inputEditorModalData.id)
                    element.notas = e
            });
        },   
        openEditorModal(item){
            this.inputEditorModalData.itemModel = item.local
            this.inputEditorModalData.id = item.id
            this.editorModal=true
        },
        dataChanged(){
            if(this.obras.length == 1){
                this.fields.obra_id = this.obras[0].Id
                this.changeWork()
            }
        },
        deleteLine(id){
            if(this.line.length == 1){
                this.error_message = "Não pode apagar a única linha que tem"
                this.error = true
                return
            }
                
            let index = this.line.findIndex(item => item.id == id);

            this.line.splice(index, 1);

            if(!id.includes('new'))
                this.deletedLines.push(id)
        },
        changeFrenteObra(){
            if(this.fields.obra_id == null)
                return

            if(this.fields.frente_id == null)
                return

            let frente = null
            this.frentes_obra.forEach(element => {
                if(element.ID == this.fields.frente_id)
                    frente = element
            });

            if(frente != null){
                if(frente.classes.length > 0){
                    this.classes = frente.classes
                    this.classeNeeded = true
                }else 
                    this.showContent = true
            }

            this.showContent = true
            
        },
        addLineToTable(){
            this.line.push({
                id: dayjs().unix() + '-new',
                classe_id: null,
                natureza_id: null,
                id_lista_unidades: null,
                available_classes: this.classes,  
                producao: null,
                notas: null,
                linhas_mo_internal: [],
                linhas_mo_external: []
            })
        }, 
        async fillBaseData(){
            let data = {
                tipo: 'O'
            }
            
            await Obra.all(data).then((resp)   =>  {
                this.obras = resp.data;
            });

            NaturezaTrabalhos.all().then((resp) =>  {
                this.natureza_trabalhos = resp.data
            })
        },
        async changeWork(){
            if(this.method == 'create'){
                let canIgo = await this.getData()
                if(canIgo == false)
                    return
            }

            let ObraPai = null
            // Vou obter o ObraPai que é o código da obra, para obter a sua frente
            // Códigos exemplo: 0110203 é da obra MOLHE SINES 3ª F
            // Vamos à tabela ObraFrente ver quais as obras que têm esse código
            this.obras.forEach(element => {
                if(element.Id == this.fields.obra_id)
                    ObraPai = element.Codigo
            });

            FrenteObra.all(ObraPai).then((resp) =>  {
                this.frentes_obra = resp.data

                this.line.forEach(element => {
                    this.frentes_obra.forEach(f => {
                        if(element.obra_frente_id == f.ID)
                            element.available_classes = f.classes
                    });
                });

                if(this.frentes_obra.length == 0){
                    this.classeNeeded = true
                    this.showContent = true
                    this.classesPorObra()
                }else{
                    if(this.frentes_obra.length == 1){
                        this.fields.frente_id = this.frentes_obra[0].ID

                        this.changeFrenteObra()
                    }
                }
            })
            
            let data = {
                get_object: true
            }
            UnidadesObra.findByWork(this.fields.obra_id, data).then((resp)    =>  {
                this.mqt = resp.data
            })

            this.loadMaoObra()
            this.loadEquipamentos()
            this.loadMateriais()
            this.loadSubempreitadas()

            this.showContent = true
        },
        classesPorObra(){
            // Também temos de verificar se esta obra tem classes
            Classe.getClassesByObraPai(this.fields.obra_id).then((resp) =>  {
                this.classes = resp.data

                if(this.classeNeeded){
                    this.line.forEach(element => {
                        element.available_classes = this.classes
                    });
                }
                
                if(this.classes.length == 1){
                    this.fields.classe_id = this.classes[0].ID

                    this.changeClasse()
                }
            })
        },
        changeClasse(){
            if(this.fields.obra_id == null)
                return
            
            if(this.fields.classe_id == null)
                return

            this.showContent = true
        }
    },
    computed:{   
        getSubempreitadasList(){
            const resultado = [];
            this.subempreitadas_diaria.forEach(subempreitada => {
                this.getLines.forEach(linha_kpi => {
                    if (subempreitada.classe_extended_id === linha_kpi.classe_id && linha_kpi.natureza_id !== undefined) {
                        
                        const subempreitadaObj = this.subempreitadas_array.find(m => m.Id === subempreitada.subempreitada_obra_id);
                        const naturezaObj = this.natureza_trabalhos.find(n => n.id === linha_kpi.natureza_id);
                        const classeObj = this.classes.find(c => c.ID === subempreitada.classe_extended_id);
                        
                        if (!subempreitadaObj || !naturezaObj || !classeObj) return;


                        // Verifica se já existe na lista (evita duplicados)
                        const exists = resultado.some(r =>
                            r.subempreitada.Id === subempreitadaObj.id &&
                            r.natureza.id === naturezaObj.id &&
                            r.classe.ID === classeObj.ID
                        );

                        if (!exists) {
                            resultado.push({
                                subempreitada: subempreitadaObj,
                                referencia: subempreitada,
                                natureza: naturezaObj,
                                classe: classeObj,
                                producao: linha_kpi.producao,
                            });
                        }
                    }
                });
            });

            if(this.fields.subempreitadas == undefined)
                return resultado;
                

            this.fields.subempreitadas.forEach(subempreitada => {
                this.getLines.forEach(linha_kpi => {
                    if (subempreitada.classe_id === linha_kpi.classe_id && linha_kpi.natureza_id !== undefined) {
                        
                        const subempreitadaObj = this.subempreitadas_array.find(m => m.Id === subempreitada.subempreitada_id);
                        const naturezaObj = this.natureza_trabalhos.find(n => n.id === linha_kpi.natureza_id);
                        const classeObj = this.classes.find(c => c.ID === subempreitada.classe_id);

                      

                        if (!subempreitadaObj || !naturezaObj || !classeObj) return;


                        // Verifica se já existe
                        const existsIndex = resultado.findIndex(r =>
                            r.subempreitada.subempreitada_id === subempreitadaObj.id &&
                            r.natureza.id === naturezaObj.id &&
                            r.classe.ID === classeObj.ID
                        );


                        if (existsIndex !== -1) {
                            // Se já existe, atualiza a quantidade
                            resultado[existsIndex].referencia.qty = subempreitada.qty;
                        } else {
                            // Se não existe, adiciona novo
                            resultado.push({
                                subempreitada: subempreitada,
                                referencia: subempreitada,
                                natureza: naturezaObj,
                                classe: classeObj,
                                producao: linha_kpi.producao,
                            });
                        }
                    }
                });
            });


            return resultado;
        },
        getMaterialsList() {
            const resultado = [];

            // ------ fonte "diária bruta"
            this.materiais_diaria.forEach(material => {
                this.getLines.forEach(linha_kpi => {
                if (material.classe_id === linha_kpi.classe_id && linha_kpi.natureza_id !== undefined) {
                    const materialObj = this.materiais.find(m => m.artigo === material.codigo_artigo);
                    const naturezaObj = this.natureza_trabalhos.find(n => n.id === linha_kpi.natureza_id);
                    const classeObj   = this.classes.find(c => c.ID === material.classe_id);
                    if (!materialObj || !naturezaObj || !classeObj) return;

                    // key única por combinação
                    const key = `${materialObj.artigo}|${classeObj.ID}|${naturezaObj.id}`;

                    // referência única desta combinação (lida e escrita pelo v-model)
                    const referencia = this.ensureMatRef(key, {
                    artigo: materialObj.artigo,
                    classe_id: classeObj.ID,
                    natureza_id: naturezaObj.id,
                    qty: (material.qty == '.000000' ? 0 : material.qty)
                    });

                    // evita duplicados visuais
                    if (!resultado.some(r => r._key === key)) {
                    resultado.push({
                        _key: key,                      // opcional, útil para debug/keys
                        material: materialObj,
                        referencia,                     // <- **esta** é única por combinação
                        natureza: naturezaObj,
                        classe: classeObj,
                        producao: linha_kpi.producao,
                    });
                    }
                }
                });
            });

            // ------ fonte "normalizada" (this.fields.materials)
            if (Array.isArray(this.fields.materials)) {
                this.fields.materials.forEach(mat => {
                const artigo   = mat.artigo;
                const classeId = mat.classe_id;
                const classeObj = this.classes.find(c => c.ID === classeId);
                if (!classeObj) return;

                const materialObj =
                    this.materiais.find(m => m.artigo === artigo) ||
                    { id: String(artigo), artigo, descricao: '(artigo não encontrado no catálogo)', unidade_base: '' };

                (mat.naturezas || []).forEach(n => {
                    const naturezaObj = this.natureza_trabalhos.find(x => x.id === n.natureza_id);
                    if (!naturezaObj) return;

                    const key = `${materialObj.artigo}|${classeObj.ID}|${naturezaObj.id}`;
                    const referencia = this.ensureMatRef(key, {
                    artigo,
                    classe_id: classeId,
                    natureza_id: naturezaObj.id,
                    qty: n.qty
                    });

                    if (!resultado.some(r => r._key === key)) {
                    resultado.push({
                        _key: key,
                        material: materialObj,
                        referencia,
                        natureza: naturezaObj,
                        classe: classeObj,
                        producao: null,
                    });
                    }
                });
                });
            }

            return resultado;
        },
        groupedSubempreitadas(){
            const agrupado = {};

            this.getSubempreitadasList.forEach(entry => {
                const classe = entry.classe?.Descricao || 'Sem Classe';
                const natureza = entry.natureza?.natureza || 'Sem Natureza';
                const subempreitada = entry.subempreitada;
                const producao = entry.producao;

                if (!agrupado[classe]) {
                agrupado[classe] = {};
                }

                if (!agrupado[classe][natureza]) {
                agrupado[classe][natureza] = [];
                }

                // Adiciona material + produção no array
                agrupado[classe][natureza].push({
                    descricao: subempreitada.Descricao,
                    referencia: entry.referencia,
                    classe: entry.classe,
                    natureza: entry.natureza,
                    subempreitada: entry.subempreitada,
                    id: subempreitada.id,
                    producao: producao,
                });
            });
            return agrupado;
        },
        groupedMaterials() {
            const agrupado = {};

            this.getMaterialsList.forEach(entry => {
                const classe = entry.classe?.Descricao || 'Sem Classe';
                const natureza = entry.natureza?.natureza || 'Sem Natureza';
                const material = entry.material;
                const producao = entry.producao;

                if (!agrupado[classe]) {
                agrupado[classe] = {};
                }

                if (!agrupado[classe][natureza]) {
                agrupado[classe][natureza] = [];
                }

                // Adiciona material + produção no array
                agrupado[classe][natureza].push({
                    descricao: material.descricao,
                    referencia: entry.referencia,
                    classe: entry.classe,
                    natureza: entry.natureza,
                    material: entry.material,
                    id: material.id,
                    producao: producao,
                    unidade: material.unidade_base,
                });
            });

            return agrupado;
        },
        getLines(){
            return this.line
        },        
        showNature(){
            let returner = true
            this.obras.forEach(element => {
                if(this.fields.obra_id == element.Id){
                    if (new Date(element.DataCriacao) >= new Date('2024-09-01'))
                        returner = false
                }
            });
            return returner
        }
    }
}
</script>
<style>
.v-text-field__slot label,input{
    font-size: 13px !important;
}

.v-list-item__title{
    font-size: 13px !important;
}

.v-select__slot label,input{
    font-size: 13px !important;
}
</style>